export default __webpack_public_path__ + "static/media/shieldTickYellow.a38a504e.svg";